export class YoutubeVideoModule {
	constructor() {
		this.videos = document.querySelectorAll("[data-yt-video-url]");
		this.players = {};

		if (this.videos) {
			this.loadApi();
		}
	}

	addListeners() {
		document.querySelectorAll("[data-play-button]").forEach(element => {
			element.addEventListener('click', (e) => this.handlePlayButtonClick(e));
		});
	}

	handlePlayButtonClick(e) {
		const videoBlock = e.currentTarget.closest("[data-yt-video-url]");
		const videoId = this.parseVideoId(videoBlock.dataset.ytVideoUrl);

		if (!videoId) {
			return;
		}

		this.playVideo(videoId);
	}

	onVideoEnded(videoId) {
		this.getPlaceHolderElementFromId(videoId).classList.remove('active');
	}

	playVideo(videoId) {
		this.players[videoId].playVideo();
		this.getPlaceHolderElementFromId(videoId).classList.add('active');
	}

	getPlaceHolderElementFromId(id) {
		const selector = this.players[id].dataSelectorAttribute;
		const videoBlock = document.querySelector(`[data-yt-video-url='${selector}']`);

		return videoBlock.querySelector(".block__video__video-placeholder");
	}

	loadApi() {
		const tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		window.onYouTubePlayerAPIReady = this.onApiLoaded.bind(this);
	}

	onApiLoaded() {
		this.videos.forEach((item) => {
			const url = item.dataset.ytVideoUrl;
			const videoId = this.parseVideoId(url);
			const placeholderElement = item.querySelector(".block__video__video-placeholder");

			if (videoId) {
				this.players[videoId] = new YT.Player(placeholderElement, {
					width: '960',
					height: '540',
					videoId: videoId,
					host: 'https://www.youtube-nocookie.com',
					playerVars: {
					  'showinfo': 0,
					  'rel': 0
					},
					events: {
					  'onStateChange': (event) => {
							if (event.data === YT.PlayerState.ENDED) {
								this.onVideoEnded(videoId);
							}
					  },
					}
				});
				this.players[videoId].dataSelectorAttribute = url;
			}
		});

		this.addListeners();
	}

	parseVideoId(url) {
		const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/; // eslint-disable-line no-useless-escape
		const match = url.match(regExp);

		if (match && match[2]) {
			return match[2];
		}

		console.error('Cannot retrieve youtubeId from given url');
		return null;
    }
}
